import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6055fd5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "users h-full bg-primary-50" }
const _hoisted_2 = { class: "left-panel sidebar fixed" }
const _hoisted_3 = { class: "w-full text-right" }
const _hoisted_4 = { class: "searchbar flex" }
const _hoisted_5 = { class: "inline-block align-middle name" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "button bg-white text-primary cursor-pointer" }, "Vedi", -1))
const _hoisted_7 = { class: "inline-block align-middle name" }
const _hoisted_8 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.isActive)
          ? (_openBlock(), _createBlock(_component_PrimaryButton, {
              key: 0,
              class: "bg-primary-900 text-white",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.userDetails()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Dettagli")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          class: "text px-4 py-3 flex-grow",
          type: "text",
          placeholder: "Cerca dipendente",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
          onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.search()), ["enter"]))
        }, null, 544), [
          [_vModelText, _ctx.searchQuery]
        ]),
        _createVNode(_component_PrimaryButton, {
          class: "button bg-white text-primary flex-none",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.search()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cerca")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["list overflow-auto", { disabled: !_ctx.isActive }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (employee, i) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            class: "link bg-white text-black justify-between flex flex-row font-bold align-middle focus:outline-none focus:shadow-outline",
            key: employee.id,
            to: `/reports/${employee.id}`,
            type: "button"
          }, {
            default: _withCtx(() => [
              _createElementVNode("label", _hoisted_5, _toDisplayString(employee.name) + " " + _toDisplayString(employee.surname), 1),
              _hoisted_6
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["list overflow-auto", { disabled: _ctx.isActive }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (employee, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "link bg-white text-black justify-between flex flex-row font-bold align-middle focus:outline-none focus:shadow-outline",
            key: employee.id
          }, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(employee.name) + " " + _toDisplayString(employee.surname), 1),
            _createVNode(_component_Checkbox, { class: "checkbox self-center pl-4" })
          ]))
        }), 128))
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            name: "slide-fade",
            mode: "in-out"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ])
  ]))
}